import React from "react";
import { FilterChip } from "../../../ui";
import { CheckCircleIcon } from "@heroicons/react/20/solid";

interface EvaluationCriteriaProps {
  criteria: string[];
}

/**
 * Presentational component for displaying evaluation criteria as chips.
 * Uses the default token FilterChip — criteria are not a category that hue
 * needs to distinguish, so they carry none (#1545).
 */
export function EvaluationCriteria({ criteria }: EvaluationCriteriaProps) {
  if (criteria.length === 0) {
    return null;
  }

  return (
    <div className="mb-5">
      <label className="text-sm font-semibold text-muted-foreground block mb-2">
        Evaluation Criteria
      </label>
      <div className="flex flex-wrap gap-2">
        {criteria.map((criterion, index) => (
          <FilterChip
            key={index}
            icon={<CheckCircleIcon className="h-4 w-4" />}
              className="px-3 py-1.5 text-sm"
            >
              <span className="font-medium">{criterion}</span>
            </FilterChip>
        ))}
      </div>
    </div>
  );
}
